/* src/app/views/product-create-search/new-eligibility/new-eligibility.component.scss */
.container {
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
  width: 100%;
  max-width: none;
  margin: 0 0 24px;
  box-sizing: border-box;
  border-radius: 6px;
  overflow: visible;
}
.container-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  float: left;
  margin-top: 20px;
}
.title {
  display: flex;
  flex-wrap: wrap;
  font-weight: normal;
  font-style: normal;
  font-size: 30pt;
  line-height: 50px;
  color: #333333;
  margin-left: 48px;
  margin-top: 10px;
}
form {
  border-radius: unset;
  padding: unset;
  box-shadow: unset;
}
.container-body {
  margin-top: 20px;
  margin-bottom: 20px;
  border: none;
}
.new-itens {
  padding: 8px 36px 0;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.element-text-select {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: -12px;
  margin-left: -12px !important;
  margin-bottom: 4px;
}
.element-text-select > [class*=col-] {
  padding: 0 12px 16px;
}
.element-text-select > .col-12.p-md-6.p-lg-4 {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.element-text-select > .element-option-select,
.element-text-select > .element-add-edit {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.element-text-select > .col-12.p-md-12.p-lg-12 {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.element-text-select > .textarea-row {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.element-option-select,
.element-add-edit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  width: 100%;
}
.element-option-select-filter,
.selected-edit-title,
.element-add-edit-label {
  margin-bottom: 6px;
}
.element-add-edit-input {
  margin-top: 0;
  min-height: 40px;
  width: 100%;
}
.element-option-select .p-dropdown,
.element-option-select .ui-dropdown,
.element-option-select .p-multiselect,
.element-option-select .ui-multiselect,
.element-option-select input[pInputText] {
  width: 100% !important;
  min-height: 40px;
}
textarea.large-text {
  width: 100% !important;
  min-height: 96px !important;
  height: 96px !important;
}
.select-width,
.description-width {
  width: 100%;
}
.position-top-select,
.position-top-select-two,
.position-top-select-center,
.position-top-select-input,
.position-top-select-max,
.top-space {
  margin-left: 0 !important;
  margin-top: 0 !important;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.actions-section {
  width: 100%;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  margin-top: 20px;
  margin-left: 0;
  padding: 22px 36px 40px;
  max-width: 1240px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.btn-save {
  width: 137px;
  height: 48px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-save-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return {
  width: 137px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #046cea;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-return-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.btn-return:hover {
  background: #044ea7;
}
button.btn-return:hover .btn-return-label {
  color: #ffffff;
}
@media only screen and (max-width: 1024px) {
  .title {
    margin-left: 30px;
    font-size: 24pt;
    line-height: 36px;
  }
  .new-itens {
    padding: 8px 24px 0;
    max-width: 100%;
  }
  .button-position {
    padding: 20px 24px 28px;
  }
}
@media only screen and (max-width: 768px) {
  .title {
    margin-left: 20px;
    font-size: 18pt;
    line-height: 28px;
  }
  .new-itens {
    padding: 8px 16px 0;
  }
  .button-position {
    gap: 10px;
    padding: 18px 16px 20px;
  }
  .element-text-select > .col-12.p-md-6.p-lg-4 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .element-text-select > .element-option-select,
  .element-text-select > .element-add-edit,
  .element-text-select > .textarea-row {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
.element-add-edit-label,
.element-add-edit-filter,
.element-option-select-filter,
.selected-edit-title {
  font-size: 1.0625rem;
  line-height: 1.35;
  font-weight: 500;
}
.char-counter {
  font-size: 0.875rem;
  line-height: 1.35;
}
::ng-deep .container .p-inputtext,
::ng-deep .container .p-dropdown-label,
::ng-deep .container .p-multiselect-label,
::ng-deep .container .p-dropdown-item,
::ng-deep .container .p-multiselect-option {
  font-size: 1rem;
  line-height: 1.4;
}
::ng-deep .container .p-message .p-message-text {
  font-size: 0.9375rem;
  line-height: 1.4;
}
/*# sourceMappingURL=new-eligibility.component-YOGO4VCV.css.map */
